var _mask, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_9_1404",
    fill: "#f00"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.94508 0 0 8.94586 0 20C0 31.0549 8.94586 40 20 40C31.0549 40 40 31.0541 40 20C40 8.94508 31.0541 0 20 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.94508 0 0 8.94586 0 20C0 31.0549 8.94586 40 20 40C31.0549 40 40 31.0541 40 20C40 8.94508 31.0541 0 20 0Z",
    fill: "#1A89A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20C1 9.49812 9.49739 1 20 1V-1C8.39277 -1 -1 8.3936 -1 20H1ZM20 39C9.49812 39 1 30.5026 1 20H-1C-1 31.6072 8.3936 41 20 41V39ZM39 20C39 30.5019 30.5026 39 20 39V41C31.6072 41 41 31.6064 41 20H39ZM20 1C30.5019 1 39 9.49739 39 20H41C41 8.39277 31.6064 -1 20 -1V1Z",
    fill: "white",
    mask: "url(#path-1-inside-1_9_1404)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.67773L21.3768 17.2316L20 29.4428L13.4449 30.8919C12.8491 31.0232 12.2716 30.6131 12.1968 30.0101L11.3397 23.0467L8.13097 17.3012C7.84713 16.7912 8.04106 16.149 8.5571 15.8809L14.6489 12.7197L19.2606 7.98959C19.4548 7.79064 19.7205 7.67773 19.9979 7.67773H20Z",
    fill: "#F9B42A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8711 17.297L28.6933 23.0467L27.8025 30.0149C27.7249 30.6159 27.148 31.024 26.5537 30.8919L20.0165 29.4394L20 29.4428V7.67774C20.2802 7.67705 20.5431 7.78926 20.7366 7.98684L25.3841 12.7197L31.4449 15.8823C31.9584 16.1505 32.1516 16.7892 31.8711 17.297Z",
    fill: "#FFA64D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.0584L20.5278 17.071L20 15.9931C19.9876 15.9924 19.9759 15.9924 19.9635 15.9924H17.7784C17.2071 15.9924 16.7458 16.4578 16.7458 17.0251V24.873C16.7458 25.4431 17.2084 25.9057 17.7784 25.9057C18.3485 25.9057 18.8111 25.4431 18.8111 24.873V22.4911C19.2379 22.489 19.6964 22.487 19.9635 22.487C19.9759 22.487 19.9876 22.487 20 22.4863L20.3901 21.3621L20 20.421C19.9883 20.4217 19.9759 20.4217 19.9635 20.4217C19.6971 20.4217 19.2441 20.4238 18.8207 20.4259C18.8145 19.2018 18.8186 19.608 18.8138 18.0577H19.9635C19.9759 18.0577 19.9883 18.0577 20 18.0584Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.9932V18.0584C20.6485 18.0777 21.1889 18.6112 21.1889 19.2397C21.1889 19.869 20.6485 20.4018 20 20.4211V22.4863C21.7981 22.4671 23.2541 21.0179 23.2541 19.2397C23.2541 17.4616 21.7981 16.0124 20 15.9932Z",
    fill: "#F4F6F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPoints);
export default __webpack_public_path__ + "static/media/my-points.aabc66c6.svg";
export { ForwardRef as ReactComponent };